import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { AppProviders } from "./app/providers";
import { AppRouter } from "./app/routes/AppRouter";

import "./theme/vendor/sb-admin-2.css";
import "./theme/tokens.css";
import "./theme/icat-overrides.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element is missing");
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppProviders><AppRouter /></AppProviders>
    </BrowserRouter>
  </React.StrictMode>,
);
